import { IconChevronChevronRight } from '@doltech/icons/IconChevronChevronRight';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import { BreadcrumbProps as AntBreadcrumbProps } from 'antd';
import { isNil } from 'lodash';
import { useRouter } from 'next/router';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../colors-v2';
import { Link } from '../Link';
import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';

const Main = styled.div.withConfig({
  componentId: 'BreadcrumbDolVn_Main',
} as any)`
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  transition: all 0.2s ease;
  text-transform: uppercase;
  .breadcrumb-item {
    margin-bottom: 0;
    padding: 4px;
    a {
      color: ${colorsV2.blue100};
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .dol-breadcrumb-separator {
    margin: 0 4px;
    color: ${colorsV2.gray100};
    font-size: 16px;
    line-height: 0;
  }
`;

const IconWrapper = styled.i.withConfig({
  componentId: 'BreadcrumbDolVn_IconWrapper',
} as any)`
  top: 1px;
  position: relative;
  color: ${colorsV2.gray100};
  line-height: 20px;
`;

interface BreadcrumbDolVnProps extends AntBreadcrumbProps {
  useFor?: 'landing-blog' | '';
}

const BreadcrumbDolVnBase = (props: BreadcrumbDolVnProps) => {
  const { useFor, routes, ...rest } = props;
  const router = useRouter();

  return (
    <Main className="dol-breadcrumb" {...rest}>
      {routes.map((route, routeIndex) => {
        const { breadcrumbName, path } = route;
        const isCurrentPath =
          `${router.basePath}${router.asPath}` === path || router?.asPath === path || isNil(path);
        const isShowSeparator = routeIndex < routes.length - 1;
        return (
          <React.Fragment key={breadcrumbName + path}>
            <p className="breadcrumb-item" key={breadcrumbName + path}>
              {isCurrentPath ? (
                <ResponsiveTypography.Text ellipsis={{ tooltip: breadcrumbName }}>
                  {breadcrumbName}
                </ResponsiveTypography.Text>
              ) : (
                <Link href={getLandingUrlFromPath(path, useFor)}>
                  <ResponsiveTypography.Text ellipsis={{ tooltip: breadcrumbName }}>
                    {breadcrumbName}
                  </ResponsiveTypography.Text>
                </Link>
              )}
            </p>
            {isShowSeparator && (
              <IconWrapper>
                <IconChevronChevronRight className="dol-breadcrumb-separator" />
              </IconWrapper>
            )}
          </React.Fragment>
        );
      })}
    </Main>
  );
};

export const BreadcrumbDolVn = BreadcrumbDolVnBase;
